import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { DetalleInversionComponent } from '../detalle-inversion/detalle-inversion.component';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MaterialModule, DetalleInversionComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.less'
})
export class HomeComponent {


}
